import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UrlService } from 'app/core/http/url.service';
import { Observable } from 'rxjs';
import { DemoCoursesModel } from 'app/shared/models/demo-courses.model';
import { TransientTeacherRegistrationModel } from 'app/shared/models/transient-teacher-registration.model';
import { LoginTokenModelWithClass } from 'app/shared/models/login-token-model-with-class';

@Injectable({
  providedIn: 'root'
})
export class TeacherRegistrationDataService {
  public constructor(
    public readonly httpClient: HttpClient,
    public readonly urlService: UrlService) { }

  public getDemoCourses(localeId: string): Observable<DemoCoursesModel> {
    const url = this.urlService.buildServerApiUrl('Teacher/Registration/DemoCourses', localeId);

    return this.httpClient.get<DemoCoursesModel>(url);
  }

  public registerForFreeGameShow(model: TransientTeacherRegistrationModel): Observable<LoginTokenModelWithClass> {
    const url = this.urlService.buildServerApiUrl('Teacher/Registration/RegisterTransient');

    return this.httpClient.post<LoginTokenModelWithClass>(url, model);
  }
}